import { taggedSum } from 'daggy';
import { Just, Maybe, get, tryFind } from 'pratica';
import moment from 'moment';

const Format = taggedSum('Format', {
  EmailMessage: [],
  CardExperience: []
});

const Size = taggedSum('Size', {
  Mobile: [],
  Desktop: []
});

const init = {
  format: Format.EmailMessage,
  size: Size.Desktop,
  text1: '',
  text2: '',
  text3: '',
  location: '',
  date: ''
};

const actionTypes = {
  SET_FORMAT_EMAIL: 'zola/cards/digitalPreview/SET_FORMAT_EMAIL',
  SET_FORMAT_CARD: 'zola/cards/digitalPreview/SET_FORMAT_CARD',
  SET_SIZE_MOBILE: 'zola/cards/digitalPreview/SET_SIZE_MOBILE',
  SET_SIZE_DESKTOP: 'zola/cards/digitalPreview/SET_SIZE_DESKTOP',
  RECEIVE_CUSTOMIZATIONS: 'zola/cards/digitalPreview/RECEIVE_CUSTOMIZATIONS'
};

export const setFormatEmail = () => ({ type: actionTypes.SET_FORMAT_EMAIL });
export const setFormatCard = () => ({ type: actionTypes.SET_FORMAT_CARD });
export const setSizeMobile = () => ({ type: actionTypes.SET_SIZE_MOBILE });
export const setSizeDesktop = () => ({ type: actionTypes.SET_SIZE_DESKTOP });
const receiveCustomizations = payload => ({ type: actionTypes.RECEIVE_CUSTOMIZATIONS, payload });

export const fetchCustomizations = () => (dispatch, getState) => Just(getState())
  .chain(get(['cards', 'project', 'customizationTypeToUUID', 'INVITATION_ENVELOPE']))
  .cata({
    Just: uuid => fetch(`/web-api/v2/card-project/customization/${uuid}`)
      .then(res => (res.ok ? res.json() : Promise.reject()))
      .then(data => dispatch(receiveCustomizations(data)))
      .catch(),
    Nothing: () => Promise.reject()
  });

const elementField = (elements, field) => Maybe(elements)
  .chain(tryFind(element => element.tag === field))
  .chain(get(['body']))
  .cata({
    Just: text => text,
    Nothing: () => ''
  });

export const preview = (state = init, action) => {
  switch (action.type) {
    case actionTypes.SET_FORMAT_EMAIL:
      return {
        ...state,
        format: Format.EmailMessage
      };
    case actionTypes.SET_FORMAT_CARD:
      return {
        ...state,
        format: Format.CardExperience
      };
    case actionTypes.SET_SIZE_MOBILE:
      return {
        ...state,
        size: Size.Mobile
      };
    case actionTypes.SET_SIZE_DESKTOP:
      return {
        ...state,
        size: Size.Desktop
      };
    case actionTypes.RECEIVE_CUSTOMIZATIONS:
      return Maybe(action.payload)
        .chain(get(['pages', 0, 'elements']))
        .map(elems => ({
          ...state,
          text1: elementField(elems, 'TEXT_1'),
          text2: elementField(elems, 'TEXT_2'),
          text3: elementField(elems, 'TEXT_3'),
          location: elementField(elems, 'LOCATION'),
          date: moment(elementField(elems, 'DATE')).format('ll')
        }))
        .cata({
          Just: newState => newState,
          Nothing: () => state
        });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/cards/reducers/digitalPreview.js